import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import TMLoader from "../../../../components/Loader/Loader";
import {
  getReasonsListThunk,
  getCheckerReasonsListThunk,
} from "../../../../redux/PickerTO/Action";
import { InputNumber, Modal, Select, message } from "antd";
import { markCheckerIssueThunk } from "../../../../redux/TOThunks/Action";

const { Option } = Select;
export class CheckerIssueModal extends Component {
  state = {
    currBatchQty: null,
    currReason: null,
    runnerData: [],
  };

  componentDidMount = () => {
    this.props.togglePageLoading(true);

    this.props
      .getCheckerReasonsListThunk({
        access_token: this.props.access_token,
        reasonType: "CHECKER_REASON",
      })
      .then(() => {
        this.props.togglePageLoading(false);

        if (this.props.reasonsListFailure) {
          message.error(this.props.reasonsListFailure);
        } else {
          this.setState({
            runnerData: this.props.reasonsListSuccess?.filter(
              (k) => k.name === "TRANSFER_ORDER_SKU_STATUS" && k.active
            ),
          });
        }
      });
  };

  saveMissingMeds = () => {
    this.props.togglePageLoading(true);

    //    private String status;

    if (!this.props.boxId) {
      message.warning("Invalid box number !");
      return;
    }

    let params = {
      access_token: this.props.access_token,
      history: this.props.history,
      data: {
        toNumber: this.props.toId,
        boxNumber: this.props.boxId,
        productCode: this.props.selectedMed?.productCode,
        checkerId: this.props.checkerTO.medDetailsForBox?.checkerId,
        skuName: this.props.selectedMed?.skuName,
        quantity: this.props.selectedMed?.quantity,
        lineId: this.props.selectedMed?.lineId,
        reasonId: this.state.currReason,
        orderValue: this.props.checkerTO.medDetailsForBox?.orderValue,
        checkedQty: 0,
        issueQty: this.state.currBatchQty,
      },
    };

    this.props.markCheckerIssueThunk(params).then(() => {
      this.props.togglePageLoading(false);

      if (this.props.TOReducer?.TOCheckerIssueMedErr) {
        message.error(this.props.TOReducer?.TOCheckerIssueMedErr);
      } else {
        this.props.history.push("/to-checker");
      }
    });
  };

  render() {
    let { view, close, selectedMed } = this.props;
    let { runnerData, currBatchQty, currReason } = this.state;
    return (
      <>
        <Modal
          title="Medicine Issue ?"
          open={view}
          centered
          onOk={() => this.saveMissingMeds()}
          onCancel={() => close(false)}
          className="medIssueModal"
          okText="Submit"
          okButtonProps={{
            disabled: !currBatchQty || !currReason,
          }}
        >
          <InputNumber
            min={1}
            max={selectedMed?.quantity}
            style={{ width: "100%", marginBottom: "1em" }}
            placeholder="Add Qty"
            onChange={(value) => this.setState({ currBatchQty: value })}
          />

          <Select
            showSearch
            placeholder="Select Reason"
            optionFilterProp="children"
            style={{ width: "100%" }}
            disabled={!currBatchQty}
            size="large"
            value={currReason}
            onChange={(value) =>
              this.setState({
                currReason: value,
              })
            }
          >
            {runnerData?.map((i, l) => (
              <Option key={l} value={i.reasonId}>
                {i.value}
              </Option>
            ))}
          </Select>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
  reasonsListSuccess: state.pickerTOReducer.reasonsListCheckerSuccess,
  reasonsListFailure: state.pickerTOReducer.reasonsListCheckerError,
  checkerTO: state.checkerTOReducer,
});

const mapDispatchToProps = {
  getReasonsListThunk,
  markCheckerIssueThunk,
  getCheckerReasonsListThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CheckerIssueModal)
);
